import React from 'react';

export interface IProps {
  fillColor?: string;
}

const AvatarIcon: React.FC<IProps> = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 8C18 11.31 15.31 14 12 14C8.69 14 6 11.31 6 8C6 4.69 8.69 2 12 2C15.31 2 18 4.69 18 8ZM16.59 13.27C15.36 14.36 13.75 15 12 15C10.25 15 8.64 14.36 7.41 13.27C4.77 14.83 3 17.72 3 21V22H21V21C21 17.72 19.23 14.83 16.59 13.27Z" fill={props.fillColor ?? "#2B3A66"} />
    </svg>
  )
}

export default AvatarIcon;